import { Component, OnInit, Input, } from '@angular/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import {Router} from '@angular/router';
import { OpenCookieWidgetDirective } from '../../../directives/openCookieWidget.directive';
import { NgClass } from '@angular/common';
import {PlatformService} from "../../../services/platform-service.service";

@Component({
  selector: 'app-seo-footer',
  templateUrl: './seo-footer.component.html',
  styleUrls: ['./seo-footer.component.scss'],
  standalone: true,
  imports: [NgClass, OpenCookieWidgetDirective, TranslateModule]
})
export class SeoFooterComponent implements OnInit {
  @Input() lang: string;
  @Input() blog;

  year;

  constructor(
    private router: Router,
    public translate: TranslateService,
    private platformService : PlatformService,

) { }

  ngOnInit(): void {
    this.year = new Date().getFullYear();
  }

  goTo(link, sublink?){
    if(this.platformService.isBrowserPlatform()){
      if(link == 'contact'){
        if(this.lang == 'fr'){
          window.location.href = 'https://help.livin-france.com/knowledge/kb-tickets/new';
        }
        else {
          window.location.href = 'https://help.livin-france.com/en/knowledge/kb-tickets/new';
        }
      }
      else if(sublink){
        window.location.href = link;
      }
      else if(link == 'visa'){
        this.router.navigate(['/visa-subscription/' + this.translate.currentLang]);
      }
      else {
        this.router.navigate([link]);
      }
    }

  }

}
